import { useTranslation } from "react-i18next";

import { useGetCertificationStatsQuery } from "@/redux/service";
import StatCard from "@/features/certifications/admin/components/StatCard";
import { AdminStatsProps } from "@/features/certifications/admin/components/types";

import "./styles.css";

const AdminStats = ({ certification }: AdminStatsProps) => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetCertificationStatsQuery(certification.slug);

  const waitingForReview = data
    ? data.reviewQueue.knowledgeChecks.pendingHuman +
      data.reviewQueue.contributions.pendingHuman
    : null;

  return (
    <dl
      className="admin-stats flex flex-wrap gap-300"
      aria-label={t("certification.admin.stats.label")}
    >
      <StatCard
        label={t("certification.admin.stats.enrolled")}
        value={data?.enrollments.active ?? null}
        isLoading={isLoading}
      />

      <StatCard
        label={t("certification.admin.stats.certificatesIssued")}
        value={data?.credentials.issued ?? null}
        isLoading={isLoading}
      />

      <StatCard
        label={t("certification.admin.stats.waitingForReview")}
        value={waitingForReview}
        isLoading={isLoading}
        hint={t("certification.admin.stats.waitingForReviewHint")}
      />

      <StatCard
        label={t("certification.admin.stats.pendingInvites")}
        value={data?.invites.pending ?? null}
        isLoading={isLoading}
      />
    </dl>
  );
};

export default AdminStats;
